import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useReportsData } from '../../hooks/useReportsData';
import { Download, Loader2, ArrowUpDown, Search } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { StatusBadge } from '../../components/badges/StatusBadge';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../components/ui/table';

export const PortfolioReport = () => {
    const [searchParams] = useSearchParams();
    const filters = {
        client: searchParams.get('client'),
        period: searchParams.get('period'),
    };
    const { trademarks, loading } = useReportsData(filters);
    const [searchTerm, setSearchTerm] = useState('');

    // Local filtering (Search)
    const displayTrademarks = trademarks.filter(tm =>
        tm.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tm.expediente.includes(searchTerm)
    );

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h2 className="text-xl font-bold text-gray-900">Portafolio de Marcas</h2>
                    <p className="text-sm text-gray-500">Inventario completo y estatus legal</p>
                </div>
                <div className="flex gap-2">
                    <Button variant="outline" size="sm"><Download className="mr-2 h-4 w-4" /> Exportar</Button>
                </div>
            </div>

            <Card className="border-gray-200">
                <CardHeader className="pb-3 border-b border-gray-100 bg-gray-50/50">
                    <div className="flex items-center justify-between">
                        <CardTitle className="text-base text-gray-700">Listado de Registros</CardTitle>
                        <div className="relative w-64">
                            <Search className="absolute left-2 top-2.5 h-4 w-4 text-gray-400" />
                            <Input
                                placeholder="Buscar marca o exp..."
                                className="pl-8 h-9 text-sm"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                </CardHeader>
                <CardContent className="p-0">
                    {loading ? (
                        <div className="p-12 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-gray-400" /></div>
                    ) : displayTrademarks.length === 0 ? (
                        <div className="p-12 text-center text-gray-500 text-sm">No se encontraron marcas con los filtros actuales.</div>
                    ) : (
                        <Table>
                            <TableHeader>
                                <TableRow className="bg-gray-50">
                                    <TableHead className="w-[100px]">Expediente</TableHead>
                                    <TableHead>Marca</TableHead>
                                    <TableHead>Clase</TableHead>
                                    <TableHead>Estatus</TableHead>
                                    <TableHead>Vigencia</TableHead>
                                    <TableHead>Titular</TableHead>
                                    <TableHead className="text-right">Acción</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {displayTrademarks.map((tm) => (
                                    <TableRow key={tm.id}>
                                        <TableCell className="font-mono text-xs">{tm.expediente}</TableCell>
                                        <TableCell className="font-medium text-gray-900">{tm.name}</TableCell>
                                        <TableCell>{tm.class}</TableCell>
                                        <TableCell>
                                            <span className={`inline-flex px-2 py-0.5 text-xs rounded-full font-medium ${tm.status === 'Registrada' ? 'bg-green-100 text-green-800' :
                                                    tm.status === 'En trámite' ? 'bg-blue-100 text-blue-800' :
                                                        'bg-gray-100 text-gray-800'
                                                }`}>
                                                {tm.status}
                                            </span>
                                        </TableCell>
                                        <TableCell className="text-sm">{tm.vigencia}</TableCell>
                                        <TableCell className="text-sm text-gray-500 max-w-[150px] truncate">{tm.titular}</TableCell>
                                        <TableCell className="text-right">
                                            <Button variant="ghost" size="sm" className="h-8 text-xs">Ver detalle</Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};
